"use strict";

exports.__esModule = true;
exports.insertScript = insertScript;
exports.removeScript = removeScript;
exports.debounce = debounce;

function insertScript(src, id, parent) {
  var script = window.document.createElement('script');
  script.async = true;
  script.src = src;
  script.id = id;
  parent.appendChild(script);
  return script;
}

function removeScript(id, parent) {
  var script = window.document.getElementById(id);

  if (script) {
    parent.removeChild(script);
  }
}

function debounce(func, wait, runOnFirstCall) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;

    var deferredExecution = function deferredExecution() {
      timeout = null;

      if (!runOnFirstCall) {
        func.apply(context, args);
      }
    };

    var callNow = runOnFirstCall && !timeout;
    window.clearTimeout(timeout);
    timeout = setTimeout(deferredExecution, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
}